import React, { useState } from 'react'
import TopBar from '../../components/admin/TopBar'
import CreateServiceModal from '../../components/admin/CreateServiceModal'
import EditServiceModal from '../../components/admin/EditServiceModal'
import axios from 'axios'
import Swal from 'sweetalert2'
import DataTable from 'react-data-table-component'
import useFetch from '../../hooks/useFetch'

import { useAuth } from '../../context/AuthContext'
import { ucwords } from '../../utils/Ucwords'
import { useNavigate } from 'react-router-dom' 

const ServicePage = () => {
    const API_URL = process.env.REACT_APP_API_URL;

    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedService, setselectedService] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate(); 
    const { user } = useAuth();

    const openCreateModal = () => setIsCreateModalOpen(true);
    const closeCreateModal = () => setIsCreateModalOpen(false);

    const openEditModal = (service) => {
        setselectedService(service);
        setIsEditModalOpen(true);
    };

    const closeEditModal = () => {
        setselectedService(null);
        setIsEditModalOpen(false);
    };

    const handleAdd = (id) => {
        navigate(`/admin/service/milestone/${id}`); 
    };

    const handleEdit = (service) => {
        openEditModal(service);
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        });
    
        if (result.isConfirmed) {
            try {
                const token = localStorage.getItem('token'); // Retrieve token from local storage
                const deleteHiring = await axios.delete(`${API_URL}/services/${id}`, {
                    headers: {
                      'Authorization': `Bearer ${token}` // Attach token to headers
                    }
                });
                const { message } = deleteHiring.data;
                refetch();

                // Show success message
                Swal.fire({
                    title: 'Deleted!',
                    text: message,
                    icon: 'success',
                    showConfirmButton: false,
                    timer: 3000
                });
            } catch (error) {
                console.error('Error deleting hiring position:', error);
                Swal.fire(
                    'Error!',
                    'There was an error deleting the position.',
                    'error'
                );
            }
        }
    };
    
    const { data, refetch } = useFetch(`${API_URL}/services`);

    const filterServices = data.filter(service => {
        return (
            `${ucwords(service.code)} ${ucwords(service.service)}`.toLowerCase().includes(searchTerm.toLowerCase())
        );
    });
    

    const columns = [
        {
            name: 'Code',
            selector: row => `${(row.code).toUpperCase()}`,
            sortable: true,
        },
        {
            name: 'Services',
            selector: row => `${ucwords(row.service)}`,
            sortable: true,
        },
        ...(user.role_name === 'Head Admin' || user.role_name === 'Senior Admin' ? [
            {
                name: 'Action',
                cell: row => (
                    <div className="flex space-x-2">
                        <button
                            className="text-green-500 hover:text-green-700"
                            onClick={() => handleAdd(row.id)} 
                        >
                            <i className="fa-solid fa-circle-plus"></i>
                        </button>

                        <button
                            className="text-blue-500 hover:text-blue-700"
                            onClick={() => handleEdit(row)}
                        >
                            <i className="fa-solid fa-pen-to-square"></i>
                        </button>

                        <button
                            className="text-red-500 hover:text-red-700"
                            onClick={() => handleDelete(row.id)}
                        >
                            <i className="fa-solid fa-trash"></i>
                        </button>
                    </div>
                )
            }
        ] : [])

    ];

    const customStyles = {
        headCells: { style: { fontWeight: 'bold', fontSize: '14px' } },
    };

    return (
        <>
            <CreateServiceModal 
                isOpen={isCreateModalOpen} 
                onClose={closeCreateModal} 
                onSuccess={refetch} 
            />
            
            <EditServiceModal  
                isOpen={isEditModalOpen} 
                onClose={closeEditModal} 
                onSuccess={refetch} 
                service={selectedService} 
            />

            <TopBar />
            <div className="p-2 mt-16">
                <div className="flex flex-col">
                    <div className="flex pb-2 justify-between border-b-2">
                        <div className="font-semibold text-xl">
                            <label>List of Services</label>
                        </div>
                        {(user.role_name === 'Head Admin' || user.role_name === 'Senior Admin')&& (
                            <button onClick={openCreateModal} className="text-white bg-[var(--customRed)] hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">
                                Create Service
                            </button>
                        )}
                    </div>
                    <div className='mt-3'>
                        <div className='flex justify-end gap-3'>
                            <label htmlFor='search' className='mt-1.5'>Search:</label>
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="form-input p-1.5 block border-gray-300 rounded-lg shadow-sm focus:ring-green-800 focus:border-green-800 mb-1"
                            />
                        </div>
                        <DataTable
                            columns={columns}
                            data={filterServices}
                            pagination
                            responsive
                            highlightOnHover
                            pointerOnHover
                            paginationPerPage={10}
                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                            customStyles={customStyles}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default ServicePage
